import { applicantsRequests } from "@/src/api/applicantsRequests";
import type { AdmissionTaskPrefillPayload } from "@/src/hooks/useAdmissionTaskPrefill";
import { buildAdmissionPrefillPayloadFromApplicant } from "@/src/utils/tasks/buildAdmissionPrefillPayloadFromApplicant";

export const fetchAdmissionPrefillPayloadByApplicantId = async (
  applicantId: string | number,
): Promise<AdmissionTaskPrefillPayload | null> => {
  const normalizedId =
    typeof applicantId === "number" ? applicantId : Number.parseInt(String(applicantId).trim(), 10);

  if (!Number.isFinite(normalizedId) || normalizedId <= 0) return null;

  const applicant = await applicantsRequests.getById(normalizedId);
  if (!applicant) return null;

  return buildAdmissionPrefillPayloadFromApplicant(applicant);
};
